import React from 'react';

import './App.css';
import 'antd/dist/antd.css'
import 'antd/dist/antd.js'
import 'antd/dist/antd.min.js'
import MainLayout from './layout/Dashboard/Main'



function App() {
  return (
    <div className="App">
       
          <MainLayout/>
     
         
        
    </div>
  );
}

export default App;
